import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';

/**
 * The floating label `SuiTooltipDirective` renders inline (as a sibling of the
 * trigger). Hosts the inverted, borderless "box" (see the scoped SCSS) and
 * renders **either** a plain string (`text`) **or** a projected `TemplateRef`
 * (`template`) — so an icon / rich content tooltip needs no rewrite, just
 * `[suiTooltip]="someTemplate"`.
 *
 * Not used directly; the directive creates it via `ViewContainerRef` and feeds
 * `text`/`template`/`id` with `setInput`.
 */
@Component({
  selector: 'sui-tooltip',
  standalone: true,
  imports: [NgTemplateOutlet],
  template: `
    @if (template) {
      <ng-container [ngTemplateOutlet]="template"></ng-container>
    } @else {
      {{ text }}
    }
  `,
  styleUrl: './sui-tooltip.component.scss',
  host: {
    class: 'sui-tooltip',
    role: 'tooltip',
    '[id]': 'id',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuiTooltipComponent {
  @Input() text = '';
  @Input() template?: TemplateRef<unknown>;
  @Input() id = '';
}
